import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useUrlChangeHandler } from '../../hooks/useUrlChangeHandler';
import BrowseFilter from '../../components/cards/filter/BrowseFilter';
import BrowseCard from '../../components/cards/card/BrowseCard';
import CardsContainer from '../../components/cards/CardsContainer';

const BrowsePage = () => {
  const mountedRef = useRef(false);
  const {
    products,
    loading,
    dataLoading,
    error,
    hasMore,
    totalResults,
    searchTerm,
    isInitialized,
    lastSearch
  } = useSelector(state => state.filter);

  // Handle URL changes
  useUrlChangeHandler();

  // Handle component lifecycle
  useEffect(() => {
    if (!mountedRef.current) {
      mountedRef.current = true;
    }

    return () => {
      if (mountedRef.current) {
        mountedRef.current = false;
      }
    };
  }, []);

  // `loading` is only ever set for a fresh (offset 0) search; pagination uses
  // `loadingMore`, which CardsContainer reads from the store. There is no
  // spinner flashing to debounce here — the container keeps the grid mounted
  // and shows the full-page spinner only when nothing has rendered yet.
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-[1920px] mx-auto px-2 sm:px-4 lg:px-8 py-6">
        <div className="flex flex-col gap-6">
          {/* Filter Section - always full width */}
          <div className="w-full">
            <div className="bg-white shadow-sm rounded-lg">
              <BrowseFilter />
            </div>
          </div>

          {/* Cards Section - always full width */}
          <div className="w-full">
            <div className="bg-white shadow-sm rounded-lg p-3 sm:p-4 md:p-6">
              <CardsContainer
                loading={loading}
                error={error}
                hasMore={hasMore}
                totalResults={totalResults}
                searchTerm={searchTerm}
                dataLoading={dataLoading}
                isInitialized={isInitialized}
                lastSearch={lastSearch}
              >
                {products.map(product => (
                  <BrowseCard
                    key={product.id}
                    product={product}
                  />
                ))}
              </CardsContainer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrowsePage; 